import { unAuthorized } from '../Utility';
import {
  urlDefalutApi,
  UNAUTHORIZED_CODE,
  keyAes,
} from '../Utility/TypeValues';
import store from '../store';
import { setAnswerNotSave } from '../Actions/AppAction';
import AES from 'crypto-js/aes';
import { isNullOrUndefined } from '../Utility/index';
import {
  CONDUCT_COUNTRY_LIST,
  CONDUCT_COUNTRY_OPTIONS,
  CONDUCT_SET_RENDER_TEXT,
  // CONDUCT_SET_SURVEY_QUESTIONS,
} from 'src/ActionTypes/ConductType';
export const aesEncrypted = (dataJson) => {
  dataJson = JSON.stringify(dataJson);
  return AES.encrypt(dataJson, keyAes);
};
export const detectUrlGetConductByBrower = (url) => {
  var isIE11 = document.documentMode <= 11;
  if (isIE11) {
    return url + '?date=' + new Date().getTime();
  }
  return url;
};
export const getConductData = (param, token) => {
  const locations = [
    {
      id: 0,
      location: 'Siam Piwat',
      location_full: 'Siam Piwat',
      location_logo: 'logo/logo-siampiwat.svg',
    },
    {
      id: 1,
      location: 'Siam Paragon',
      location_full: 'CRM customers (HNW)',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 2,

      location: 'Siam Paragon',
      location_full: 'Redemption Counter_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 3,

      location: 'Siam Paragon',
      location_full: 'Service (ONESIAM app counter)_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 4,

      location: 'Siam Paragon',
      location_full: 'Service (ONESIAM/Tourist lounges)_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 5,

      location: 'Siam Paragon',
      location_full: 'Service (Platinum lounges)_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 6,

      location: 'Siam Paragon',
      location_full: 'Troop_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 7,

      location: 'Siam Paragon',
      location_full: 'Car Park_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 8,

      location: 'Siam Paragon',
      location_full: 'SPW Retail_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 9,

      location: 'Siam Paragon',
      location_full: 'Information counter_SPD',
      location_logo: 'logo/Logo-siamparagon.svg',
    },
    {
      id: 10,
      location: 'Siam Center',
      location_full: 'Redemption Counter_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 11,
      location: 'Siam Center',
      location_full: 'Service (ONESIAM app counter)_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 12,
      location: 'Siam Center',
      location_full: 'Troop_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 13,
      location: 'Siam Center',
      location_full: 'Car Park_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 14,
      location: 'Siam Center',
      location_full: 'SPW Retail_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 15,
      location: 'Siam Center',
      location_full: 'Information counter_SC',
      location_logo: 'logo/Logo-siamcenter.svg',
    },
    {
      id: 16,
      location: 'Siam Discovery',
      location_full: 'Redemption Counter_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 17,
      location: 'Siam Discovery',
      location_full: 'Service (ONESIAM/Tourist lounges)_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 18,
      location: 'Siam Discovery',
      location_full: 'Troop_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 19,
      location: 'Siam Discovery',
      location_full: 'Tenant (rotate bimonthly)_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 20,
      location: 'Siam Discovery',
      location_full: 'SPW Retail_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 21,
      location: 'Siam Discovery',
      location_full: 'Information counter_SD',
      location_logo: 'logo/Logo-siamdiscovery.svg',
    },
    {
      id: 22,
      location: 'ICONSIAM',
      location_full: 'Redemption Counter_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 23,
      location: 'ICONSIAM',
      location_full: 'Service (ONESIAM app counter)_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 24,
      location: 'ICONSIAM',
      location_full: 'Service (ONESIAM/Tourist lounges)_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 25,
      location: 'ICONSIAM',
      location_full: 'Troop_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 26,
      location: 'ICONSIAM',
      location_full: 'Tenant (rotate bimonthly)_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 27,
      location: 'ICONSIAM',
      location_full: 'SPW Retail_ICON_ICONCRAFT',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 28,
      location: 'ICONSIAM',
      location_full: 'SPW Retail_ICON_OTHER',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 29,
      location: 'ICONSIAM',
      location_full: 'Information counter_ICON',
      location_logo: 'logo/Logo-iconsiam.svg',
    },
    {
      id: 30,
      location: 'ICS',
      location_full: 'Redemption Counter_ICS',
      location_logo: 'logo/Logo-ics.svg',
    },
    {
      id: 31,
      location: 'ICS',
      location_full: 'Troop_ICS',
      location_logo: 'logo/Logo-ics.svg',
    },
    {
      id: 32,
      location: 'ICS',
      location_full: 'Information counter_ICS',
      location_logo: 'logo/Logo-ics.svg',
    },
  ];
  const parts = param.split('/');

  // const id = Number(parts[1]);
  const id = parts[1];

  // ถ้า id ไม่อยู่ใน locations ให้ return null
  if (!locations.some((location) => String(location.id) === id)) {
    return null;
  }

  // api-code xz5pmi091o
  const url = detectUrlGetConductByBrower(`${urlDefalutApi}/${param}`);
  // const url = detectUrlGetConductByBrower(`${urlDefalutApi}/survey/xz5pmi091o`);

  const header = new Headers({
    Param: window.location.search.replace('?', ''),
    Token: token,
  });
  const myInit = {
    method: 'GET',
    headers: header,
    mode: 'cors',
    cache: 'default',
  };
  return fetch(url, myInit).then(async function (response) {
    if (response.ok) {
      const location = locations.find((location) => String(location.id) === id);

      if (!location) {
        return null;
      }
      store.dispatch({
        type: CONDUCT_SET_RENDER_TEXT,
        payload: location,
      });

      await fetchCountryOptions();

      return response.json();
    }
  });
};

export const fetchCountryOptions = async () => {
  try {
    const res = await fetch(`${urlDefalutApi}/country`);
    const data = await res.json();

    store.dispatch({
      type: CONDUCT_COUNTRY_LIST,
      countryList: data,
    });
  } catch (error) {
    console.error('Failed to fetch countries:', error);
  }
};

const setCountryOptions = async (languageId = 2) => {
  const data = store.getState().conductReducer.countryList;
  const options = data.map((item) => ({
    value: String(item.id),
    label: languageId === 2 ? item.countryName : item.countryNameCN,
  }));

  store.dispatch({
    type: CONDUCT_COUNTRY_OPTIONS,
    countryOptions: options,
  });
};

export const fetchChoices = (choices) => {
  const otherElements = new Set([
    'เซ็นทรัลอื่นๆ',
    'เดอะมอลล์อื่นๆ',
    'อื่นๆ',
    'ไม่มี',
    'ไม่แสดงความคิดเห็น',
    'Other',
    '其它',
    '其他',
    '没有意见',
    'อื่นๆระบุ',
    'เดอะมอลล์อื่นๆระบุ',
    'เซ็นทรัลอื่นๆระบุ',
    'อื่นๆโปรดระบุ',
    'เดอะมอลล์อื่นๆโปรดระบุ',
    'เซ็นทรัลอื่นๆโปรดระบุ',
    'ตั้งใจจะมาซื้อของ/ใช้บริการแต่"ไม่ได้ของ/บริการที่ต้องการ"',
    "ตั้งใจจะมาซื้อของ/ใช้บริการแต่'ไม่ได้ของ/บริการที่ต้องการ'",
    'ไม่ได้ใช้บริการใดๆเลย',
    'อื่นๆโปรดระบุ',
    'OtherCentral',
    'OtherTheMall',
    '没有',
    'Nocomment',
  ]);

  const normalize = (text) => text.trim().replace(/\s/g, '');

  let normalChoices = choices.filter(
    (choice) => !otherElements.has(normalize(choice.name)),
  );
  let specialChoices = choices.filter((choice) =>
    otherElements.has(normalize(choice.name)),
  );

  // Shuffle normalChoices
  normalChoices.sort(() => Math.random() - 0.5);

  return normalChoices.concat(specialChoices);
};

export const getConductDataLanguages = (param, token) => {
  const url = detectUrlGetConductByBrower(`${urlDefalutApi}/${param}`);
  // const isRandom = store.getState().conductReducer.surveyQuestions.isRandom;
  const splitParam = param.split('/');
  const currentLanguageID = splitParam[2];

  const header = new Headers({
    Param: window.location.search.replace('?', ''),
    Token: token,
  });
  const myInit = {
    method: 'GET',
    headers: header,
    mode: 'cors',
    cache: 'default',
  };
  return fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
    })
    .then(async (data) => {
      await setCountryOptions(Number(currentLanguageID));
      const elementKeysQuestionShuffleChoices = [
        '569FE152-1A10-4D4B-B21A-8BFA5CB2B706',
        '1443FA94-C371-4627-85A6-D418C20E3975', // MAIN
        'F187429A-1138-476B-9269-B430A1A48AC8',
        'BCA67065-CD80-4069-9E4C-D5B76BC5C9C7',
        'FFCC339F-8726-4EF1-B595-326918919B1E', // Siam Center (สยาม เซ็นเตอร์)
        '9BD7F75B-F007-4262-89F6-ECA1977A727F',
        'E14F10FA-8C00-4F95-B188-011A0EBA0A0F',

        '816A37CF-E74B-4CAD-8BCD-B75157E61CB7', // Siam Discovery (สยาม ดิสคัฟเวอรี่)
        '5531AC4C-FF28-4DCC-9FF5-F880E49D5D53',
        '7B1A2EC8-3B66-4615-9964-CA5DC44D03A7',

        '73D41FF0-837D-468B-A6F5-D55E10F88C77', // Siam Paragon (สยาม พารากอน)
        '0E58C68C-3C67-435C-BC6B-685B74E95A93',
        '5464A008-003F-4F20-BF9C-C5E1EEB68EEB',

        '5BAADD56-F40F-4D80-BEC8-353A66086EEB', // Central World (เซ็นทรัลเวิลด์)
        '3B46E17C-FDD7-4622-8B09-E7221BE33769',
        '1EBE4219-3CA9-4FE2-A1BE-6ED8509695BD',

        'C109A1B9-07BE-4D40-8301-581545869D2F', // Emporium (เอ็มโพเรียม)
        '89A66D63-A586-4A6B-A1E2-3875F91483A7',
        '92ECAFCC-2FD5-4580-93F2-734D4665C503',

        '48185685-CDB5-41B1-8B1B-B9EFC472A10E', // EmQuartier (เอ็มควอเทียร์)
        '5B080E52-2127-4CE3-80C3-70F57F89797D',
        '11112114-0CE1-42C7-A1BD-696972FD9BBB',

        '8169ED51-FE37-4EE4-B7BF-4D5A0D4467D9', // EMSPHERE (เอ็มสเฟียร์)
        '17301CCD-D211-4C60-B67C-A8FAD17AF421',
        'C58B5582-53BB-4E1E-B986-81124074BC09',

        '6C42BE8F-E9D7-4E5B-B4AE-77F796C31C53', // Central Chidlom (เซ็นทรัลชิดลม)
        'A9F910D8-7038-497B-8A5D-D787472692BB',
        '4E88DCF5-2D9B-4836-859E-EF02C2B65C02',

        '6062C598-8908-4C19-B59A-9A708EB3C03F', // Central Embassy (เซ็นทรัล เอ็มบาสซี)
        '59DC3BAC-676C-46D1-A164-E2E69CD34A46',
        'EC04853D-EFB3-498A-8EBE-36ED1BFBCD2C',

        '745B0AE5-E2FD-440C-847D-988F770CE88B', // Gaysorn Village (เกษรวิลเลจ)
        '8869F6AA-0E62-4744-80F1-AB14767B6533',
        '3C787AE1-7CEE-4426-A137-D59284F4CB3B',

        '89916E04-8A42-4784-A26A-B8D8D223616B', // ICONSIAM (ไอคอนสยาม)
        'A2D0F7E2-9D16-4305-A8CB-3D50793C944B',
        '35D26219-0DF0-49AB-AF6C-2751F98CD7B8',

        'F32EFF0E-6AFF-4373-BB2A-95A2A5BF0537', // ICS (ไอซีเอส)
        'AE3C9505-578B-489E-B8B1-74AC5EDAD6CF',
        '826BE7AE-E2B8-4EE7-8008-F1E4F661D9B7',

        '3AF77C44-96A7-4684-9BCB-FF61565A9129', // ONE BANGKOK (วัน แบงค็อก)
        '0C75B8CB-77DB-4D66-9A35-EF150BD1F74A',
        '5E27F331-DAF2-402E-8CDB-2B1DBE87DC9C',

        'CA3AF4F0-4C27-4B50-A489-D2BE4509958A', // MegaBangna (เมกาบางนา)
        '700D03BC-DE15-4357-AA0B-407AD9748D8B',
        '3B573D80-9300-4DED-8328-456549DBB581',

        '8424AD88-B25B-4B64-834E-554D888222FD', // Central Ladprao (เซ็นทรัลลาดพร้าว)
        'A2D5DD7A-6D01-4884-A956-5EF90CBCC774',
        '6B31F4C2-BB2D-4233-BE1E-E16072498BD3',

        '0881EE4E-FCA3-4014-8228-D6A25F724266', // other 1
        '3C67B7A7-08AA-48FB-94CA-E79F1493DBB8',
        'CD298148-5954-4FF7-BCEA-25783FD4DC51',

        '51484C04-C3C9-4DBA-9D7C-4FB0E9604363', // other 2
        'AB93A409-97A8-45BC-A127-9C811B227F59',
        'E1DB47FC-BC89-46FB-BB6B-121B59DEBF4B',

        '2A968420-ACD5-4858-A7E5-415715A94EBD', // other 3
        'EC3B9B61-0765-45B6-9E1A-49B4625D121D',
        '1E6827BF-92C6-4CEF-9C01-382031BFE059',

        'CB0168CF-166F-48B1-9D01-D2A2F4E55C9E', // other language
        'E4E58617-CFD6-48D8-AB44-D38AD5653B2F', // negative
        'DCE62F77-FCC3-4CBC-A785-3739C709FBA9', // positive
        '192DFC58-DE59-459B-9F68-825FFAF31EF5', // en q7
        '569FE152-1A10-4D4B-B21A-8BFA5CB2B706',

        '7152F1D7-5956-4C76-9602-9390F5C2AA47', // th q2.1
      ];

      const findQuestions = data.questions.filter((question) =>
        elementKeysQuestionShuffleChoices.includes(question.elementKey),
      );

      findQuestions.forEach((question) => {
        const questionChoices = question.choices;
        const fetch_choices = fetchChoices(questionChoices);
        question.choices = fetch_choices;
      });

      // นำ findQuestions ไปใช้ใน data.questions
      data.questions = data.questions.map((question) => {
        const foundQuestion = findQuestions.find(
          (q) => q.elementKey === question.elementKey,
        );
        if (foundQuestion) {
          return foundQuestion;
        }
        return question;
      });

      return data; // คืนค่าข้อมูล JSON
    });
};

export const getConductQuestion = (id) => {
  const url = `${urlDefalutApi}/getquestions/${id}`;
  const myHeaders = new Headers({
    Param: window.location.search.replace('?', ''),
  });
  const myInit = {
    method: 'GET',
    headers: myHeaders,
    mode: 'cors',
    cache: 'default',
  };

  return fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
    })
    .catch((error) => console.error('Error:', error));
};

export const saveStartConduct = (accessToken, conductID, token) => {
  const url = `${urlDefalutApi}/response/start/${conductID}`;
  // const url = `${urlDefalutApi}/conduct/${conductID}/start`;
  const headers = new Headers({
    Param: window.location.search.replace('?', ''),
    // Authorization: `Bearer ${accessToken}`
  });
  const init = {
    method: 'POST',
    headers: headers,
    mode: 'cors',
    cache: 'default',
  };

  return fetch(url, init)
    .then(function (response) {
      if (response.ok) {
        return response.json();
      } else if (response.status === UNAUTHORIZED_CODE) {
        unAuthorized(response);
      }
    })
    .catch((error) => {});
};

export const saveFinishConduct = (accessToken, conductID, token, callBack) => {
  let isError = false;
  const url = `${urlDefalutApi}/response/finish/${conductID}`;
  // const url = `${urlDefalutApi}/conduct/${conductID}/finish`;
  const headers = new Headers({
    Param: window.location.search.replace('?', ''),
    // Authorization: `Bearer ${accessToken}`
  });
  const init = {
    method: 'POST',
    headers: headers,
    mode: 'cors',
    cache: 'default',
  };

  return fetch(url, init)
    .then(function (response) {
      if (response.ok) {
        callBack(true);
        return response.json();
      } else {
        callBack(false);
        isError = true;
      }
    })
    .catch((error) => {
      // console.log('saveFinishConduct');
      if (isError === false) {
        callBack(false);
      }
    });
};
const fetchAnswerRespnse = (accessToken, token, responseAnswers, callBack) => {
  let isError = false;
  const url = `${urlDefalutApi}/response/save`;
  // const url = `${urlDefalutApi}/response`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(responseAnswers),
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
      Token: isNullOrUndefined(token) ? '' : token,
      Param: window.location.search.replace('?', ''),
    }),
  })
    .then(function (response) {
      if (response.ok) {
        const listNames = [];
        responseAnswers.forEach((o) => {
          listNames.push(o.elementKey);
        });
        let logAnswers = Object.assign([], store.getState().appReducer.notsave);
        logAnswers = logAnswers.filter((f) => {
          return listNames.indexOf(f.elementKey) < 0;
        });
        store.dispatch(setAnswerNotSave(logAnswers));
        callBack(true);
        return response.json();
      } else {
        callBack(false);
        isError = true;
      }
      return response;
    })
    .catch((error) => {
      if (isError === false) {
        callBack(false);
      }
    });
};
export const saveSurveyResponse = (
  accessToken,
  token,
  responseAnswers,
  callBack,
) => {
  let logAnswers = Object.assign([], store.getState().appReducer.notsave);
  logAnswers = [...logAnswers, ...responseAnswers];
  const last = [];
  const listNames = [];
  logAnswers.forEach((e) => {
    const answers = logAnswers.filter((d) => {
      return d.elementKey === e.elementKey;
    });
    if (answers.length > 1 || answers.length === 1) {
      const a = answers[answers.length - 1];
      if (listNames.indexOf(a.elementKey) < 0) {
        listNames.push(a.elementKey);
        last.push(a);
      }
    }
  });
  store.dispatch(setAnswerNotSave(last));
  if (last.length > 0) {
    fetchAnswerRespnse(accessToken, token, last, callBack);
  } else {
    callBack(true);
  }
};
